import { Outlet } from "react-router-dom";
import Footer from "./footer";
import Header from "./header";

const Layout: React.FunctionComponent<{}> = (props) => {
  return (
    <div>
      <Header />
      <Outlet />
      {/* <Footer /> */}
    </div>
  );
};
export default Layout;
